import * as React from 'react';

// Based on ~src/teacher/components/ActivityResult/States/ActivityResultError.tsx
import { translate } from '~l10n/client';

import { NotFound } from '~teacher/components/NotFound/NotFound';

export function WorkspaceNotFound() {
  return (
    <NotFound
      summary={translate('Shared Library Not Found')}
      description={translate(
        "The library doesn't exist, or you don't have permission to view it. Ask the library owner to verify the invite link." /* eslint-disable-line */ /* prettier-ignore */
      )}
    />
  );
}
